module.exports = __webpack_public_path__ + "img/PMS_FPS.25b590e4.png";